module.exports = __webpack_public_path__ + "img/grade-F.041de742.svg";